import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import { msalInstance } from 'components/AuthWrapper';
import Loading from 'components/Loading';
import { useCurrentUser } from 'hooks';
import { loginRequest } from 'config';
import path from 'common/path';
import {
  getProfileId,
  setBusinessesId,
  removeProfileId,
  getUserEmail,
  removeUserEmail,
  logOut,
  getSSOFlag,
  removeSSOFlag,
} from 'utils/authService';

const SSO = () => {
  const { isAuthenticated, loading, user, logoutRedirect } = useCurrentUser();
  const navigate = useNavigate();
  const email = getUserEmail();

  const handleSSO = async () => {
    const accounts = msalInstance.getAllAccounts();
    const matchingAccount = accounts.find(
      (account) => account.username.toLowerCase() === email.toLowerCase(),
    );

    if (matchingAccount) {
      try {
        await msalInstance.ssoSilent({
          ...loginRequest,
          account: matchingAccount,
        });
      } catch (err) {
        await msalInstance.loginRedirect(loginRequest);
      }
    } else {
      await msalInstance.loginRedirect({
        ...loginRequest,
        loginHint: email,
      });
    }
  };

  useEffect(() => {
    const handleAuth = async () => {
      const ssoFlag = getSSOFlag();

      if (ssoFlag) {
        removeSSOFlag();
      }

      if (isAuthenticated) {
        // User is authenticated but with another email
        if (
          ssoFlag &&
          email &&
          user.username.toLowerCase() !== email.toLowerCase()
        ) {
          logOut();
          logoutRedirect();
          await handleSSO();
          return;
        }

        const businessId = getProfileId();

        setBusinessesId(businessId);
        removeProfileId();
        removeUserEmail();

        navigate(path.dashboard);
      } else if (!loading) {
        await handleSSO();
      }
    };

    handleAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-screen overflow-y-auto flex">
      <Loading loading={true} />
    </div>
  );
};

export default SSO;
